import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../../mensajes2";
import { formatMoneda, validaMonto } from "../../../util/varios";
import axios from "axios";
import { Dimmer } from "../../spinner";
import { DangerButton, SuccessButton } from "../../../ui/buttons/Button";
import { Input, Radio, Textarea } from "../../../ui/inputs/Input";

export const ModalInsertarTasa = (props) => {
  let op = require("../../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const [activate, setActivate] = useState(false);
  const txtCodigoCiu = useRef();
  const txtAlicuota = useRef();
  const txtDescripcionActi = useRef();
  const txtAnios = useRef();
  const txtCodActividad = useRef();
  const [operacion, setOperacion] = useState(0);
  const txtDescripcion = useRef();
  const txtId = useRef();
  const txtCodOr = useRef();
  const txtCantidad = useRef();
  const [periodo, setPeriodo] = useState();
  const txtRadio1 = useRef();
  const txtRadio2 = useRef();
  const txtRadio3 = useRef();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });

    if (
      mensaje.texto == "registro creado correctamente." ||
      mensaje.texto == "registro eliminado correctamente." ||
      mensaje.texto == "registro modificado correctamente."
    ) {
      blanquear();
      props.onHideRender();
      props.onHideCancela();
    }
  };

  const blanquear = () => {
    txtId.current.value = "";
    txtCodOr.current.value = "";
    txtDescripcion.current.value = "";
    txtCantidad.current.value = "";
    txtRadio3.current.checked = false;
    txtRadio1.current.checked = false;
    txtRadio2.current.checked = false;
    setActivate(false);
  };

  const handleInputChange = (event) => {
    if (event.which === 13) {
      if (event.target.id === "inputCodigo") {
        txtCodActividad.current.focus();
      } else if (event.target.id === "inputCodigoActi") {
        txtCodigoCiu.current.focus();
      } else if (event.target.id === "inputCodigoCiu") {
        txtAnios.current.focus();
      } else if (event.target.id === "inputAnio") {
        txtDescripcionActi.current.focus();
      } else if (event.target.id === "inputDescripcion") {
        txtAlicuota.current.focus();
      } else if (event.target.id === "inputActualizada") {
        btnAcepta.current.focus();
      }
    } else if (typeof event.which === "undefined") {
      return false;
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false; //alert(e.which);
  };

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (
      event.target.value === "" ||
      parseFloat(
        event.target.value.trim().replace(/\./g, "").replace(",", ".")
      ) === 0.0
    ) {
      event.target.value = "0,00";
    }
    if (event.which >= 37 && event.which <= 40) {
      event.preventDefault();
    }
    // Devuelve el número formateado
    let e = event.target.value
      .replace(/\D/g, "")
      .replace(/([0-9])([0-9]{2})$/, "$1.$2")
      .replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ",");

    return formatMoneda(e);
  };

  const salir = () => {
    props.onHideCancela();
    /* props.blanquear() */
    blanquear();
  };

  const selectRegValor = (operacion) => {
    let endpoint = `${op.conexion}/api/licores/actualizartasa/${operacion}`;
    let body;
    setActivate(true);

    body = {
      nid: parseInt(txtId.current.value),
      cod: txtCodOr.current.value.trim(),
      descr: txtDescripcion.current.value,
      val: txtCantidad.current.value
        .trim()
        .replace(/\./g, "")
        .replace(",", "."),
      peri: parseInt(periodo),
    };
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (props.operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro creado correctamente.",
              icono: "exito",
            });
          } else if (props.operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro modificado correctamente.",
              icono: "exito",
            });
          } else if (props.operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro eliminado correctamente.",
              icono: "exito",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const validar = (e) => {
    e.preventDefault();
    var sigue = true;
    if (operacion !== 4) {
      if (txtCodOr.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe Ingresar un Codigo de Ordenanza",
          icono: "informacion",
        });

        txtCodOr.current.focus();
        sigue = false;
      } else if (
        !txtRadio1.current.value &&
        !txtRadio2.current.value &&
        !txtRadio3.current.value
      ) {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe seleccionar periodo de cobranza",
          icono: "informacion",
        });

        txtCantidad.current.focus();
        sigue = false;
      } else if (txtCantidad.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe Ingresar Cantidad",
          icono: "informacion",
        });

        txtCantidad.current.focus();
        sigue = false;
      } else if (txtDescripcion.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe Ingresar una Descripcion",
          icono: "informacion",
        });

        txtDescripcion.current.focus();
        sigue = false;
      } else if (sigue === true) {
        selectRegValor(props.operacion);
      }
    }
  };

  const onChange = () => (event) => {
    if (event.target.name === "radioDeclara") {
      setPeriodo(parseInt(event.target.value));
      console.log(event.target.value);
    }
    if (event.target.id === "inputDireccionContri") {
      event.target.value = event.target.value.toUpperCase();
      console.log(event.target.value);
    }
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
      }}
      className="shadow-lg"
    >
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant rounded-top text-light">
        <h3 className="m-0 fw-bold">
          {operacion === 1
            ? "Registrar Clasificador Tasa."
            : operacion === 2
            ? "Editar Clasificador Tasa."
            : operacion === 3
            ? "Eliminar Clasificador Tasa."
            : "Consultar Clasificador Tasa"}
        </h3>
        <a type = "button"
          ref={btnCancela}
          className="fw-bold text-light fs-6"
          onClick={salir}
        >
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body className="col-12 m-0 p-2 d-flex flex-wrap">
        <div className="col-2 m-0 mb-2 p-0">
          <Input label = 'Código:'
            disabled
            ref={txtId}
            defaultValue={
              props.tipoTasa
                ? props.tipoTasa.idtipotasa !== null
                  ? props.tipoTasa.idtipotasa.trim()
                  : ""
                : ""
            }
            id="inputRitm"
            onKeyUp={handleInputChange}
            onBlur={handleInputChange}
          />
        </div>
        <div className="col-5 m-0 mb-2 p-0 pl-2">
          <Input label = 'Codigo Segun Ordenanza:'
            ref={txtCodOr}
            disabled={
              operacion === 1 ? false : operacion === 2 ? false : true
            }
            defaultValue={
              props.tipoTasa
                ? props.tipoTasa.codigo !== null
                  ? props.tipoTasa.codigo.trim()
                  : ""
                : ""
            }
            id="inputRitm"
            onKeyUp={handleInputChange}
            onBlur={handleInputChange}
          />
        </div>
        <div className="col-12 m-0 mb-2 p-0 d-flex gap-2">
          <span className="fw-bold">Periodo de Cobranza:</span>
          <div class="col-auto m-0 p-0">
            <Radio label = 'Anual'
              ref={txtRadio1}
              disabled={
                operacion === 1 ? false : operacion === 2 ? false : true
              }
              name="radioDeclara"
              value="0"
              defaultChecked={
                props.tipoTasa && props.tipoTasa.periodopago === 0
              }
              id="radioSi1"
              onChange={(event) => setPeriodo(event.target.value)}
            />
          </div>
          <div class="col-auto m-0 p-0">
            <Radio label = 'Mensual'
              ref={txtRadio2}
              disabled={
                operacion === 1 ? false : operacion === 2 ? false : true
              }
              name="radioDeclara"
              value="1"
              defaultChecked={
                props.tipoTasa && props.tipoTasa.periodopago === 1
              }
              id="radioSi2"
              onChange={(event) => setPeriodo(event.target.value)}
            />
          </div>
          <div class="col-auto m-0 p-0">
            <Radio label = 'Eventual'
              ref={txtRadio3}
              disabled={
                operacion === 1 ? false : operacion === 2 ? false : true
              }
              name="radioDeclara"
              value="3"
              defaultChecked={
                props.tipoTasa && props.tipoTasa.periodopago === 2
              }
              id="radioSi3"
              onChange={(event) => setPeriodo(event.target.value)}
            />
          </div>
        </div>
        <div className="col-12 m-0 mb-2 p-0">
          <Textarea label = 'Descripcion:'
            style={{ height: 70 }}
            disabled={
              operacion === 1 ? false : operacion === 2 ? false : true
            }
            rows={1}
            ref={txtDescripcion}
            id="inputDireccionContri"
            name="inputDireccionContri"
            defaultValue={
              props.tipoTasa
                ? props.tipoTasa.descripcion !== null
                  ? props.tipoTasa.descripcion.trim()
                  : ""
                : ""
            }
            onKeyUp={onChange}
            onChange={onChange}
          />
        </div>
        <div className="col-3 m-0 ml-auto p-0">
          <Input label = 'Cantidad:'
            inputClassName="text-end"
            ref={txtCantidad}
            disabled={
              operacion === 1 ? false : operacion === 2 ? false : true
            }
            defaultValue={
              props.tipoTasa
                ? props.tipoTasa.monto !== null
                  ? formatMoneda(
                      props.tipoTasa.monto.trim().replace(".", ","),
                      ",",
                      ".",
                      2
                    )
                  : ""
                : ""
            }
            id="inputCantidad"
            name="inputCantidad"
            onKeyUp={handleInputMontoChange}
            onBlur={handleInputMontoChange}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton
          onClick={validar}
        >
          Aceptar
        </SuccessButton>
        <DangerButton
          ref={btnCancela}
          onClick={salir}
        >
          Salir
        </DangerButton>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />

      <Dimmer active={activate}></Dimmer>
    </Modal>
  );
};
